<template>
  <div class="full-height">
    <div class="row center-xs no-gutter">
      <div :class="navigationClass" style="position: fixed; top: 0; left: 0; z-index: 1000;">
        <div style="height: 100vh">
          <div class="menu-container">
            <router-link to="/web/" style="margin-bottom: 40px; display: block;">
              <img src="@/assets/petronas-white.svg" class="logo" />
            </router-link>
            <router-link to="/web/" class="menu-item">
              <img src="@/assets/add.svg" />
              <div class="font-subhead font-medium text">
                {{ $language.newForm }}
              </div>
            </router-link>
            <router-link to="/web/search" class="menu-item">
              <img src="@/assets/search.svg" />
              <div class="font-subhead font-medium text">
                {{ $language.searchForm }}
              </div>
            </router-link>
            <router-link
              v-if="internalRoles.includes('OPU Administrator') || internalRoles.includes('Administrator')"
              to="/web/general-administrator/"
              class="menu-item"
            >
              <img src="@/assets/administrator.svg" />
              <div class="font-subhead font-medium text">
                {{ $language.administrator }}
              </div>
            </router-link>
            <router-link to="/web/my-account" class="menu-item">
              <img src="@/assets/dashboard.svg" />
              <div class="font-subhead font-medium text">
                {{ $language.myAccount }}
              </div>
            </router-link>
            <!-- <router-link to="/dashboard/administrator" class="menu-item">
              <img src="@/assets/administrator.svg" />
              <div class="font-subhead font-medium text">Administrator</div>
            </router-link> -->
          </div>
        </div>
      </div>
      <div class="col-xs-2  hidden-xs"></div>
      <div class="col-xs">
        <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
          <!-- <mad-appbar
            style="border-bottom: 1px solid #f1f1f1"
            class="elevation z0 background-white hidden-md hidden-lg hidden-xlg"
          >
            <mad-icon-button @click="enableToolbar = true">
              <mad-icon
                class="icon"
                style="opacity: 0.8"
                name="mdiMenu"
              ></mad-icon>
            </mad-icon-button>
            <div
              class="font-title font-bold color-grey-700"
              style="; height: 48px; line-height: 48px; float: left"
            >
              {{ title }}
            </div>
          </mad-appbar> -->
          <div class="toolbar">
            <div class="page-container">
              <div class="pull-left">
                <router-link class="pull-left" to="/web/" style="width: 40px;display: block; margin-top: 4px">
                  <img src="@/assets/petronas.svg" style="width: 100%" />
                </router-link>
                <mad-menu ref="language" class="pull-left">
                  <div
                    class="account-group"
                    v-if="getUser"
                    style="height: 48px; line-height: 48px; margin-left: 32px; cursor:pointer; font-size: 12px;"
                  >
                    {{ $getLanguage() === "my" ? "Bahasa Malaysia" : "English" }}
                    <mad-icon name="mdiChevronDown" class="pull-right color-grey-500" style="line-height: 48px;"></mad-icon>
                  </div>
                  <span slot="content">
                    <mad-list>
                      <mad-list-item :class="{ active: $getLanguage() === 'my' }" @click="changeLanguage('my')">Bahasa Malaysia</mad-list-item>
                      <mad-list-item :class="{ active: $getLanguage() === 'en' }" @click="changeLanguage('en')">English</mad-list-item>
                    </mad-list>
                  </span>
                </mad-menu>
              </div>
              <div class="pull-right">
                <mad-menu :fromRight="true" ref="menu">
                  <span class="account-group" v-if="getUser">
                    <!-- <mad-icon class="right-icon" name="mdiAccount" style="color: #8692b0"></mad-icon> -->
                    <mad-avatar
                      v-if="getUser"
                      :first-name="getUser.FullName"
                      type="extra-small"
                      style="margin-right: 8px; cursor: pointer"
                    ></mad-avatar>
                    <div class="account-name hidden-xs inline-block">
                      {{ getUser.FullName }}
                    </div>
                    <mad-icon class="right-icon" name="mdiChevronDown" type="small" style="color: #8692b0"></mad-icon>
                  </span>
                  <span slot="content">
                    <mad-list>
                      <mad-list-item @click="$router.push('/web/') && $refs.menu.activate()">{{ $language.newForm }}</mad-list-item>
                      <mad-list-item @click="$router.push('/web/search') && $refs.menu.activate()">{{ $language.searchForm }}</mad-list-item>
                      <mad-list-item
                        v-if="internalRoles.includes('OPU Administrator') || internalRoles.includes('Administrator')"
                        @click="$router.push('/web/general-administrator/') && $refs.menu.activate()"
                        >{{ $language.administrator }}</mad-list-item
                      >
                      <mad-list-item @click="$router.push('/web/my-account') && $refs.menu.activate()">{{ $language.myAccount }}</mad-list-item>
                      <hr />
                      <mad-list-item @click="logout">{{ $language.signOut }}</mad-list-item>
                    </mad-list>
                  </span>
                </mad-menu>
              </div>
            </div>
          </div>
          <div class="viewbox">
            <div class="page-container title-area">
              <div class="font-display1 font-light hidden-xs hidden-xd hidden-sm visible-md visible-lg visible-xlg">
                <router-link :to="breadCrumb.level1.to" v-if="breadCrumb.level1.title !== ''">{{ breadCrumb.level1.title }}</router-link>
                <mad-icon
                  v-if="breadCrumb.level1.title !== ''"
                  name="mdiChevronRight"
                  style="vertical-align: middle;"
                  class="color-primary"
                ></mad-icon>
                {{ title }}
              </div>
            </div>
            <div>
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </div>
    <mad-overlay v-model="loadingArea" :inverse="true">
      <div class="row middle-xs center-xs" style="height: 100vh">
        <div class="spinner-eff spinner-eff-3">
          <div class="circle circle-1"></div>
          <div class="circle circle-2"></div>
          <div class="circle circle-3"></div>
        </div>
      </div>
    </mad-overlay>

    <mad-overlay v-model="updateUserType">
      <mad-scrollbar style="min-height: 100vh;">
        <div style="height: 100vh">
          <div class="row has-gutter center-xs middle-xs" style="height: 100%; margin: 0 8px;;">
            <div class="col-xs-fluid-24 col-md-10">
              <mad-card style="border: none; overflow: hidden; border-radius: 8px; margin: 16px 0;">
                <img src="@/assets/helloThere.png" style="width: 100%; max-width: 100%;" />
                <form style="padding: 16px;" @submit.prevent="submitUserType">
                  <div class="font-bold" style="margin-bottom: 8px;">
                    Select the best to describe you before entering PETRONAS facilities:
                  </div>
                  <div class="row has-gutter">
                    <div class="col-md-fluid-24">
                      <mad-radio :label="$language.petronasStaff" val="1" v-model="userType"></mad-radio>
                    </div>
                    <div class="col-md-fluid-24">
                      <mad-radio :label="$language.contractor" val="2" v-model="userType"></mad-radio>
                    </div>
                    <div class="col-md-fluid-24">
                      <mad-radio :label="$language.visitor" val="3" v-model="userType"></mad-radio>
                    </div>
                    <div class="col-md-fluid-24" style="margin-top: 16px; margin-bottom: 8px;">
                      <div v-if="userType === '1'" class="font-bold">
                        Enter Your Staff ID (Only for PETRONAS Staff)
                      </div>
                    </div>
                    <div class="col-xs-fluid-24 col-md-fluid-12" v-if="userType === '1'">
                      <mad-textfield v-model="staffId" :placeholder="$language.staffId" :required="true"></mad-textfield>
                    </div>
                  </div>
                  <div class="clearfix">
                    <div style="padding-top: 12px;" class="pull-right">
                      <mad-button :disabled="$wait.waiting('record submission') || !userType" class="primary" button-style="raised" type="submit">
                        <mad-icon name="mdiCheck" size="small"></mad-icon>
                        Confirm
                      </mad-button>
                    </div>
                  </div>
                </form>
              </mad-card>
            </div>
          </div>
        </div>
      </mad-scrollbar>
    </mad-overlay>
  </div>
</template>

<script>
import { onLogout, jwtDecoded } from "@/vue-apollo";
import GET_USER from "@/graphql/getUser.gql";
import CHANGE_LANGUAGE from "@/graphql/changeLanguage.gql";
import UPDATE_USER_TYPE from "@/graphql/updateUserType.gql";
export default {
  data() {
    const nearestWithTitle = this.$route.matched
      .slice()
      .reverse()
      .find(r => r.meta && r.meta.title);
    return {
      enableToolbar: false,
      title: nearestWithTitle.meta.title,
      activeMenu: "main",
      getUser: null,
      internalRoles: [],
      updateUserType: false,
      userType: "",
      staffId: "",
      breadCrumb: {
        level1: {
          title: "",
          to: "",
        },
      },
      getAllModule: [],
    };
  },
  computed: {
    navigationClass() {
      let defaultClass = "col-xs-2 menu-navigation background-primary-900 hidden-xs";

      if (this.enableToolbar) return defaultClass + " active";
      return defaultClass;
    },
    loadingArea() {
      return this.$wait.is(["apollo loading", "change pages"]);
    },
    userData() {
      return jwtDecoded();
    },
  },
  methods: {
    async logout() {
      this.$refs.menu.activate();
      await onLogout(this.$apollo.provider.defaultClient);
      return this.$router.push("/");
    },
    setLanguage(lang) {
      this.$setLanguage(lang);
      this.$apollo
        .mutate({
          mutation: CHANGE_LANGUAGE,
          variables: {
            Language: lang,
          },
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    changeLanguage(lang) {
      this.setLanguage(lang);
      return this.$router.go(0);
    },
    submitUserType() {
      this.$apollo
        .mutate({
          mutation: UPDATE_USER_TYPE,
          variables: {
            Type: parseInt(this.userType),
            StaffId: this.staffId,
          },
        })
        .then(() => {
          this.updateUserType = false;
        })
        .catch(err => {
          throw new Error(err);
        });
    },
  },
  watch: {
    $route(val) {
      const nearestWithTitle = val.matched
        .slice()
        .reverse()
        .find(r => r.meta && r.meta.title);
      this.title = nearestWithTitle.meta.title;
    },
    async getUser(val) {
      if (val && val.Roles) {
        this.internalRoles = val.Roles.map(item => {
          return item.Name;
        });
        if (val.Language && !this.$getLanguage()) {
          this.$setLanguage(val.Language);
          this.$router.go(0);
        }

        if (val.Type === null) {
          this.updateUserType = true;
        }
      }
    },
  },
  created() {
    if (!localStorage.getItem("COVID-apollo-token")) {
      return this.$router.push("/");
    }
    this.$eventBus.$on("bread-crumb-level1", data => {
      this.breadCrumb.level1.title = data.title;
      this.breadCrumb.level1.to = data.to;
    });
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        // console.log("Page completed with image and files!");
        // fetch
      }
    };
    this.$nextTick(() => {
      let lang = this.$getLanguage();
      if (lang) {
        this.setLanguage(lang);
      }
    });
  },
  apollo: {
    getUser: {
      query: GET_USER,
      variables() {
        return {
          Id: this.userData.upn,
        };
      },
      error() {
        this.logout();
        return this.$router.push("/");
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@MadScss/import.scss";
// .icon-button {
//   margin: 8px 12px;
//   margin-bottom: 0;

//   & .icon {
//     color: $theme-primary-50;
//   }

//   &.active {
//     background: rgba($color-white, 0.2);
//   }
// }

.viewbox {
  height: calc(100vh - 48px);
}

// @media only screen and (max-width: 991px) {
//   .menu-navigation {
//     position: fixed;
//     top: 0;
//     left: 0;
//     z-index: 100;
//     @include transform(translateX(-100%));
//     @include transition(all 0.2s ease-in-out);
//     &.active {
//       @include transform(translateX(0));
//     }
//   }

//   .viewbox {
//     height: calc(100vh - 56px);
//   }
// }

// .custom-menu {
//   margin-top: 12px;
// }

// .menu-item {
//   width: calc(100% - 24px);
//   margin-left: 8px;
//   height: 48px;
//   line-height: 48px;
//   border-radius: 24px;
//   background: transparent;
//   padding: 0 20px;
//   cursor: pointer;
//   color: $color-white;
//   font-weight: 300;
//   font-size: 14px;
//   transition: all 0.2s ease-in-out;
//   display: block;
//   &:hover {
//     background: $theme-primary-600;
//     padding-left: 24px;
//   }
//   &.router-link-exact-active {
//     background: $theme-primary-700;
//     &:hover {
//       background: $theme-primary-800;
//     }
//   }
// }

.menu-container {
  padding: 24px;
  img {
    max-width: 100%;

    &.logo {
      width: 80%;
    }
  }

  .menu-item {
    margin: 24px 0;
    display: block;
    img {
      width: 80%;
      @include transition($animation-fast-out-slow-in-timing-function 0.2s all);
    }
    .text {
      margin-top: 8px;
      color: $theme-primary-100;
      text-align: center;
      font-size: 13px;
      @include transition($animation-fast-out-slow-in-timing-function 0.2s all);
    }

    &.router-link-exact-active {
      .text {
        color: $color-white;
      }
    }

    &:hover {
      img {
        @include transform(translateY(-10px));
      }
      .text {
        color: $color-white;
      }
    }
  }
}

.toolbar {
  height: 48px;
  border-bottom: 1px solid $color-grey-200;
  overflow-y: hidden;
  .right-icon {
    padding: 12px;
    vertical-align: middle;
    cursor: pointer;
    &:hover {
      color: $theme-primary;
      background: rgba($theme-primary, 0.1);
    }
  }

  .account-group {
    .account-name {
      padding: 12px 0;
      text-overflow: ellipsis;
      vertical-align: middle;
      white-space: nowrap;
      overflow: hidden;
      cursor: pointer;
      @media only screen and (max-width: 480px) {
        max-width: 150px;
      }
    }
    .right-icon {
      &:hover {
        background: none;
      }
    }
  }
}

.title-area {
  padding: 32px 16px;
}

$spinner-dimensions: 100px;
$spinner-3-bg: $theme-primary;

@mixin position-absolute($top: null, $left: null, $right: null, $bottom: null) {
  position: absolute;
  top: $top;
  left: $left;
  right: $right;
  bottom: $bottom;
}

.spinner-eff {
  position: relative;
  width: $spinner-dimensions;
  height: $spinner-dimensions;

  &:before,
  &:after {
    content: "";
    display: block;
  }

  .spinner-bar {
    &:before,
    &:after {
      content: "";
      display: block;
    }
  }
}

.spinner-eff.spinner-eff-3 {
  @keyframes pulse {
    0% {
      transform: scale(0);
    }

    50% {
      transform: scale(1.3);
      opacity: 0;
    }

    100% {
      transform: scale(1.3);
      opacity: 0;
    }
  }

  @keyframes pulse-2 {
    0% {
      transform: scale(0);
    }

    100% {
      transform: scale(1.3);
      opacity: 0;
    }
  }

  .circle {
    border-radius: 100px;
    @include position-absolute($left: 0, $right: 0);
    margin: auto;
    transform: scale(1);
    transform-origin: center center;

    &-1 {
      width: 100%;
      height: 100%;
      background-color: lighten($spinner-3-bg, 25%);
      top: 0;
      animation: pulse 1.6s linear 0s infinite;
    }

    &-2 {
      width: 66.6%;
      height: 66.6%;
      background-color: $spinner-3-bg;
      top: 16.5%;
      animation: pulse-2 1.6s linear 0s infinite;
    }

    &-3 {
      width: 33.3%;
      height: 33.3%;
      background-color: $spinner-3-bg;
      top: 33.3%;
    }
  }
}
</style>
